import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { WpapiService } from 'src/app/services/wpapi.service';
import { Observable, Subject } from "rxjs";
import { throttleTime } from 'rxjs/operators';
import { PageService } from 'src/app/services/page.service';
import { fadeAnimation } from 'src/app/animations/animation';
import { element } from 'protractor';
import { CompanyItemComponent } from './modules/company-item/company-item.component';
import { SeoService } from 'src/app/services/seo.service';
import { ThemeService } from 'src/app/services/theme.service';

export enum KEY_CODE {
    UP_ARROW = 38,
    DOWN_ARROW = 40
}

@Component({
    selector: 'app-company',
    templateUrl: './company.component.html',
    styleUrls: ['./company.component.scss'],
    animations: [fadeAnimation]
})
export class CompanyComponent implements OnInit {
    counter: number = 0;
    counterposition: number = 0;
    screenHeight: number;
    scrollHeight: number;
    screenWidth: number;
    isMac = navigator.platform;
    modules: any;
    menuActive: boolean = false;
    touchdirection: number = 0;
    touchstart: number = 0;
    direction: string = '';
    active = false;
    currentY;
    initialY;
    yOffset = 0;
    stopScrollAnimation: boolean = false;
    bottomStop: boolean = true;
    topStop: boolean = false;
    swiped: boolean = false;
    lastScrollTop;
    whiteLogo: boolean = false;
    private SubjectUp = new Subject<number>();
    private SubjectDown = new Subject<number>();
    private SubjectUpMac = new Subject<number>();
    private SubjectDownMac = new Subject<number>();
    isTopScroll: boolean = true;
    activateMenuOverlay: boolean = false;
    stopScroll: boolean = false;
    isDarkTheme: Observable<boolean>;
    isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
    @ViewChild('gridcontainer') gridcontainer: ElementRef;
    @ViewChild('itemcomponent') itemcomponent: CompanyItemComponent;

    constructor(private wpApi: WpapiService,
        private pageService: PageService,
        private seoService: SeoService, 
        private themeService: ThemeService) {
        this.pageService.listen().subscribe((m: boolean) => {
            this.onMenuActive(m);
        })

        this.pageService.goToTopListen().subscribe(() => {
            if (this.isIPadPro && this.screenWidth > 1024) {
                const grid = document.getElementById('main-container-wrapper');
                grid.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            } else {
                this.counter = 0;
            }
        })
        this.pageService.activateMenuOverlayListen().subscribe((resp) => {
            this.activateMenuOverlay = resp;
        })
        this.pageService.stopScrollListen().subscribe((resp) => {
            this.stopScroll = resp;
        })
    }

    onMenuActive(m) {
        this.menuActive = m;
    }

    ngOnInit() {
        this.onResize();
        window.scrollTo(0, 0);
        this.SubjectUp.asObservable()
            .pipe(
                throttleTime(200)
            ).subscribe(x => this.doSomethingWithThrottledEventUp(x));
        this.SubjectDown.asObservable()
            .pipe(
                throttleTime(200)
            ).subscribe(x => this.doSomethingWithThrottledEventDown(x));
        this.SubjectUpMac.asObservable()
            .pipe(
                throttleTime(500)
            ).subscribe(x => this.doSomethingWithThrottledEventUpMac(x));
        this.SubjectDownMac.asObservable()
            .pipe(
                throttleTime(500)
            ).subscribe(x => this.doSomethingWithThrottledEventDownMac(x));
        this.getCompany();
        this.pageService.showGoToTopButton(false);
    }

    getCompany() {
        this.wpApi.getCompany().subscribe(resp => {
            this.handleResponse(resp)
        })
    }

    handleResponse(resp) {
        this.modules = resp[0];
        this.seoService.setSeoMetaTags(resp[0]);
        this.scrollHeight = this.modules.acf.modules.length * (this.screenHeight) + this.screenHeight;
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
        if (this.modules) {
            this.scrollHeight = this.modules.acf.modules.length * (this.screenHeight) + this.screenHeight;
        }
        this.counter = 0;
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (this.screenWidth > 1024) {
            if (event.keyCode === KEY_CODE.UP_ARROW) {
                this.onScrollUp();
            }
            if (event.keyCode === KEY_CODE.DOWN_ARROW) {
                this.onScrollDown();
            }
        }
    }

    // @HostListener('window:scroll', ['$event'])
    onScroll(event) {
        this.itemcomponent.isLoadedComponent();
        if (this.screenWidth <= 1024) {
            var st = event.srcElement.scrollTop;
            var logo = document.getElementsByClassName('logo-wrapper')[0];
            var menuIcon = document.getElementsByClassName('toggle-button-container')[0];
            if (st > this.lastScrollTop) {
                logo.classList.add('hide-logo');
                menuIcon.classList.add('hide-menu');
                this.isTopScroll = true;
            } else {
                if (logo.classList.contains('hide-logo') && menuIcon.classList.contains('hide-menu')) {
                    logo.classList.remove('hide-logo');
                    menuIcon.classList.remove('hide-menu');
                    this.isTopScroll = false;
                }
            }
            this.lastScrollTop = st <= 0 ? 0 : st;
            if (st > (this.scrollHeight - this.gridcontainer.nativeElement.clientHeight - 50) || st < this.gridcontainer.nativeElement.clientHeight) {
                this.pageService.whiteLogo(true);
                this.whiteLogo = true;
            } else {
                if (this.whiteLogo) {
                    this.pageService.whiteLogo(false);
                    this.whiteLogo = false;
                }
            }
        }
        if (this.screenWidth <= 768) {
            var st = event.srcElement.scrollTop;
            if (st > (this.gridcontainer.nativeElement.clientHeight - 50)) {
                this.pageService.showGoToTopButton(true);
            } else {
                this.pageService.showGoToTopButton(false);
            }
        }
    }

    mouseWheelUpFunc(event) {
        event.preventDefault();
        if (this.screenWidth > 1024) {
            if (!(/iPhone|iPad|iPod|Android|webOS|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent))) {
                if (this.isMac == 'MacIntel' || this.isMac == 'Mac68K' || this.isMac == 'MacPPC') {
                    if (event.wheelDelta != undefined && event.wheelDelta > 80) {
                        this.SubjectUpMac.next(event);
                    }
                    if (event.detail < -2) {
                        this.SubjectUpMac.next(event);
                    }
                } else {
                    if (event.wheelDelta != undefined && event.wheelDelta > 80) {
                        this.SubjectUp.next(event);
                    }
                    if (event.detail < -2) {
                        this.SubjectUp.next(event);
                    }
                }
            }
        }
    }

    mouseWheelDownFunc(event) {
        event.preventDefault();
        if (this.screenWidth > 1024) {
            if (!(/iPhone|iPad|iPod|Android|webOS|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent))) {
                if (this.isMac == 'MacIntel' || this.isMac == 'Mac68K' || this.isMac == 'MacPPC') {
                    if (event.wheelDelta != undefined && event.wheelDelta < -80) {
                        this.SubjectDownMac.next(event);
                    }
                    if (event.detail > 2) {
                        this.SubjectDownMac.next(event);
                    }
                } else {
                    if (event.wheelDelta != undefined && event.wheelDelta < -80) {
                        this.SubjectDown.next(event);
                    }
                    if (event.detail > 2) {
                        this.SubjectDown.next(event);
                    }
                }
            }
        }
    }

    private doSomethingWithThrottledEventUp(event: any) { this.onScrollUp(); }
    private doSomethingWithThrottledEventUpMac(event: any) { this.onScrollUp(); }
    private doSomethingWithThrottledEventDown(event: any) { this.onScrollDown(); }
    private doSomethingWithThrottledEventDownMac(event: any) { this.onScrollDown(); }

    onScrollUp() {
        if (!this.stopScroll) {
            if (this.counter < 0) {
                this.counter += this.screenHeight;
                this.pageService.rotateLeftLogo();
            }
            if (this.counter > 0) {
                this.counter = 0;
                this.pageService.rotateLeftLogo();
            }
            this.counterposition = this.counter;
        }
    }

    onScrollDown() {
        if (!this.stopScroll) {
            this.counter -= this.screenHeight;
            if (this.counter < -(this.scrollHeight - this.screenHeight)) {
                this.counter = -(this.scrollHeight - this.screenHeight);
            } else {
                this.pageService.rotateRightLogo();
            }
            if (-(this.counter - this.screenHeight) == this.scrollHeight) {
                this.isDarkTheme = this.themeService.isDarkTheme;
                console.log('isDarkTheme', this.isDarkTheme);
                if(this.isDarkTheme){
                    console.log('logo dark');
                } else {
                    console.log('logo light');
                }
                this.pageService.whiteLogo(true);
            }
            this.counterposition = this.counter;
        }
    }

    scrollItem(j) {
        const scroll_item = document.getElementById('compnay-container-' + j);
        scroll_item.scrollIntoView({
            behavior: 'smooth',
        });
        const activedots = document.getElementsByClassName('gallery-dots');
        for (let index = 0; index < activedots.length; index++) {
            const activedot = activedots[index];
            if (activedot.classList.contains('active')) {
                activedot.classList.remove('active');
            }
        }
        document.getElementById('gallery-dot-' + j).classList.add('active');
    }
}
